// Chooses recent report dates when there is no existing range to preserve.
// Used for a new report and when switching Days/Weeks/Months leaves the old dates
// outside the available period options.
import { PeriodOptionSet } from './createPeriodOptions.ts';
import { PeriodOption, Resolution } from '../report-settings/reportSettings.ts';
import { getPeriods } from './getPeriods.ts';

interface PeriodRange {
    first: PeriodOption;
    last: PeriodOption;
    periodsInRange: PeriodOption[];
}

export function getDefaultPeriodRange(
    periodOptionSet: PeriodOptionSet,
    resolution: Resolution,
): PeriodRange {
    const periods = getPeriods(periodOptionSet, resolution);
    const defaultCount = resolution === 'Days' ? 7 : 5;
    // The option lists include the current unfinished period, so defaults include it too.
    const periodsInRange = periods.slice(-defaultCount);
    return {
        first: periodsInRange[0],
        last: periodsInRange.at(-1)!,
        periodsInRange,
    };
}
